import { useSyncExternalStore } from "react";
import { certificationStore } from "@/lib/certificationStore";

export function useCertifications() {
  return useSyncExternalStore(certificationStore.subscribe, certificationStore.get);
}

/**
 * Returns true once the certification store has completed its initial load
 * from the database. Use this to avoid showing premature "no certifications"
 * messages while the data is still being fetched.
 */
export function useCertificationsLoaded() {
  return useSyncExternalStore(certificationStore.subscribe, certificationStore.isLoaded);
}
